import React from "react";

import {
  Clear as ClearIcon,
  MonetizationOnOutlined as MonetizationIcon,
} from "@material-ui/icons";
import classNames from "classnames";
import { Link } from "react-router-dom";

import type { JSX } from "react";

interface Item {
  label: string;
  uuid: string;
  hasAds?: boolean;
  url?: string;
}

interface CardProps {
  label: string;
  uuid: string;
  hasAds?: boolean;
  url?: string;
  onDelete?: (uuid: string) => void;
}

function Card({ label, url, onDelete, uuid, hasAds }: CardProps): JSX.Element {
  const labelClassName = classNames(
    "flex cursor-pointer items-center rounded-l-xl py-[0.3125rem] pl-[0.625rem] hover:bg-primary hover:text-primary-foreground hover:shadow-md whitespace-nowrap",
    {
      "rounded-r-xl": !onDelete,
      "pr-[0.625rem]": !onDelete,
      "pr-[0.3125rem]": onDelete,
    },
  );
  if (url) {
    return (
      <div className="bg-muted flex rounded-[0.46875rem]">
        <div className={labelClassName}>
          <Link
            className="flex items-center gap-[0.3125rem] visited:text-current hover:text-current"
            to={url}
          >
            {hasAds ? <MonetizationIcon /> : null}
            <span>{label}</span>
          </Link>
        </div>
        {onDelete ? (
          <div className="bg-muted hover:bg-destructive/30 hover:text-destructive flex cursor-pointer items-center justify-center rounded-r-xl p-[0.3125rem]">
            <ClearIcon
              fontSize="medium"
              onClick={(e): void => {
                e.preventDefault();
                e.stopPropagation();
                onDelete(uuid);
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }
  return (
    <div className="bg-muted flex items-center gap-[0.3125rem] rounded-[0.46875rem] px-[0.625rem] py-[0.3125rem]">
      {hasAds ? <MonetizationIcon /> : null}
      <span>{label}</span>
    </div>
  );
}

interface RelatedListProps {
  items: Item[];
  title?: string;
  onDelete?: (uuid: string) => void;
}

function RelatedList({
  items,
  title,
  onDelete,
}: RelatedListProps): JSX.Element {
  return (
    <div className="flex flex-col gap-[0.3125rem]">
      {title ? <div className="text-muted-foreground">{title}</div> : null}
      <div className="ml-[0.78125rem] flex flex-wrap gap-[0.625rem]">
        {items.map((item) => (
          <Card
            key={item.uuid}
            hasAds={item?.hasAds}
            label={item.label}
            onDelete={onDelete}
            url={item?.url}
            uuid={item.uuid}
          />
        ))}
      </div>
    </div>
  );
}

export default RelatedList;
